/**
 * @ignore
 * @internal
 * */
export class ApiError {
  tryReconnect = true;
  message: string = null;

  constructor(tryReconnect = true, message: string = null) {
    this.tryReconnect = tryReconnect;
    this.message = message;
  }
}
